/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Tooltip } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Logo1 from "../../../../public/assets/icons/Logo1";
import CircleLoading from "../../common/components/CircleLoadding";
import NoDataComponent from "../../common/components/NoData";
import { accountActions } from "../redux/actions";
import { TAccountState } from "../utils/types";
import { appName } from "../../../utils/constants/constants";

const AchievementsTab = ({ memberHid }) => {
  const dispatch = useDispatch();
  const handleGetExtraInfo = () => {
    dispatch(accountActions.handleGetExtraInfo(memberHid));
  };
  const { isLoadingAchievement, extraInfo } = useSelector((state: { account: TAccountState }) => state.account);
  useEffect(() => {
    if (!extraInfo || extraInfo?.memberHid !== memberHid) {
      handleGetExtraInfo();
    }
  }, []);
  return (
    <div>
      {isLoadingAchievement ? (
        <div className="w-full flex justify-center">
          <CircleLoading />
        </div>
      ) : (
        <div className="flex w-full flex-wrap  items-center sm:justify-between md:justify-start">
          {extraInfo?.achievements?.length === 0 ? (
            <NoDataComponent />
          ) : (
            extraInfo?.achievements?.map((item, idx) => (
              <div key={idx} className="w-1/4 my-8 sm:mx-2 md:mx-0">
                <Tooltip title={item.description} placement="top-start" enterTouchDelay={0} arrow key={idx}>
                  <Box className="center-col">
                    {item?.net_icon ? (
                      <img src={item?.net_icon} alt={appName} className="w-[66px] h-[66px]" />
                    ) : (
                      <Logo1 width={66} height={66} />
                    )}
                    <span className="whitespace-nowrap text-[12px] mt-1">{item.title}</span>
                  </Box>
                </Tooltip>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};
export default AchievementsTab;
